import { apiGet } from './client';
import type { Tenant } from '../types/Tenant';

export function getTenants(): Promise<Tenant[]> {
  return apiGet<Tenant[]>('/api/tenants');
}
